import {
  Box,
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  FormHelperText,
  Typography,
  Radio,
  TextField,
  InputAdornment,
  IconButton,
  Checkbox
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";

import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { ReactComponent as CopyIcon } from "../../assets/images/copy.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/plus-circle-fill.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../assets/images/iconFile/Null-File.svg";
import { ReactComponent as JpegIcon } from "../../assets/images/iconFile/jpeg.svg";
import * as Util from "../../services/global.service";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormik } from 'formik';
import * as yup from 'yup';
import securityService from "../../services/security.service";


const useStyles = makeStyles({
  btnDisabled: {
    '& .Mui-disabled': {
      color: "#FFFFFF !important",
      backgroundColor: "#BABABA !important"
    }
  },
  blockFiles: {
    cursor: "pointer"
  },
  input: {
    ".MuiFormHelperText-root": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
    },
    ".MuiOutlinedInput-root": {
      padding: "8.5px 14px",
      ".MuiInputBase-input": {
        padding: "0"
      }
    }
  },
});
const AttachFilesgoalDialog = (props) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch();
  const handleClose = () => {
    props.setValue(false)
    setSubmitReset(false)
  };
  const { value, serial, email } = props;
  const classes = useStyles();
  // let { serial } = useParams();
  const [resetInEmail, setResetInEmail] = React.useState(true);
  const [resetRandom, setResetRandom] = React.useState(false);
  const [forceChangePassword, setForceChangePassword] = React.useState(false);
  const [isSubmitReset, setSubmitReset] = React.useState(false);
  const [errorPassword, setErrorPassword] = React.useState(false);

  const validationSchema = yup.object({
    // password: yup.string().required(t('forgotpwd.msg.password'))
    password: yup.string().required("Please enter your password")
      // .min(8, t('profile.passwordMust'))
      .min(8, "The password must contain at least 8 characters with a minimum of lower case, upper case, numeric character, and a special character.")
      .matches(
        /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*()\-_+={`~[\]\\};':/"|,.<?>])[A-Za-z\d!@#$%^&*()\-_+={`~[\]\\};':/"|,.<?>]{8,}$/,
        // t('profile.passwordMust')),
        "The password must contain at least 8 characters with a minimum of lower case, upper case, numeric character, and a special character."),
  });
  const formik = useFormik({
    initialValues: {
      password: ""
    },
    enableReinitialize: true,
    validationSchema: resetRandom ? validationSchema : null,
    onSubmit: (values) => {
      submit(values)
    },
  });

  useEffect(() => {
    if (errorPassword) {
      setErrorPassword(false)
    }
  }, [formik.values.password]);

  const handleSubmitReset = () => {
    formik.submitForm()
  }
  const handleResetInEmail = () => {
    setResetInEmail(true)
    setResetRandom(false)
  }
  const handleResetRandom = () => {
    setResetInEmail(false)
    setResetRandom(true)
  }
  const submit = (data) => {
    setSubmitReset(true)
    if (resetInEmail) {
      securityService.resetPasswordInEmai(serial).then(
        (response) => {
          props.submitReset(data, "email")
          handleClose()
        },
      ).catch((err) => {
        if (err?.data?.code === "common.msg.try_again") {
          props.submitReset(data, "warning")
        }
      })
    } else {
      securityService.resetPasswordRandom({
        user: "",
        username: "",
        pincode: "",
        new_password: data.password,
        options: {
          force_change: forceChangePassword
        },
      }, serial).then(
        (response) => {
          props.submitReset(data, "random")
          handleClose()
        },
      ).catch((err) => {
        if (err?.data?.code === "login.msg.chg_pwd_error") {
          setErrorPassword(true)
        }
      })
    }

  }
  const [copySuccess, setCopySuccess] = React.useState('');
  const handleClickCopy = async copyMe => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess('Copied!');
    } catch (err) {
      setCopySuccess('Failed to copy!');
    }
  };
  const handleForceChangePassword = () => {
    setForceChangePassword(!forceChangePassword)
  }
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  function generatePassword() {
    securityService.randomPassword().then(
      (response) => {
        formik.setFieldValue("password", response?.data?.password)
      },
    )
  }

  useEffect(() => {
    if (props.open) {
      formik.resetForm()
      setResetInEmail(true)
      setResetRandom(false)
    }
  }, [props.open]);

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="attach-file-dialog"
        aria-describedby="attach-file-description"
        PaperProps={{ sx: { padding: '10px' } }}
        component="div"
      >
        <DialogTitle id="form-add-dialog-title" fontSize={24}>
          <Typography fontWeight="600" fontSize={24} lineHeight={1.1} color="#404349">{t('security.resetPassword')}</Typography>
          <Box sx={{ position: "absolute", right: 0, margin: "30px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><CloseIcon /></Box>
          <Divider sx={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent px={3} >
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            <Grid container>
              <Grid item md>
                <Typography fontSize={16} lineHeight="23.92px" color="#404349" pb="10px">{t('security.passwordFollowing')}</Typography>
                <Box sx={{ display: "flex", alignItems: "center" }} py="10px">
                  <Radio sx={{ padding: "0" }} name="radio" value="1" checked={resetInEmail} size="small" onClick={handleResetInEmail} />
                  <Typography pl="10px" fontSize={16} lineHeight="23.92px" color="#404349">{t('security.sendRandomPasswordTo')} “{email}”</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }} py="10px">
                  <Radio sx={{ padding: "0" }} name="radio" value="2" checked={resetRandom} size="small" onClick={handleResetRandom} />
                  <Typography pl="10px" fontSize={16} lineHeight="23.92px" color="#404349">{t('security.resetPassword')}</Typography>
                </Box>
                {resetRandom ?
                  <Box sx={{ ".MuiFormHelperText-root": { mx: "14px" } }}>
                    <Box classes={{ root: classes.input }} sx={{ width: "100%", display: "flex", justifyContent: "space-between", "align-items": "center", paddingTop: "0 !important", ".MuiOutlinedInput-root": { padding: "8.5px 14px", ".MuiInputBase-input": { padding: "0" } }, ".MuiFormControl-root": { marginTop: "7px" } }}>
                      {/* <BootstrapTooltip
                        title={copySuccess}
                        placement="top"
                        leaveDelay={0.2}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener> */}
                      <TextField
                        id="valuepassword"
                        error={errorPassword ? errorPassword : Boolean(formik.touched.password && formik.errors.password)}
                        fullWidth
                        // helperText={formik.touched.password && formik.errors.password}
                        margin="normal"
                        name="password"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        type="text"
                        value={formik.values.password}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{ margin: "0", ".MuiOutlinedInput-root": { color: "#404349", } }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => handleClickCopy(formik.values.password)}
                              >
                                <CopyIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        placeholder={t('security.fillPassword')}
                      // classes={{ root: classes.input }}
                      />
                      {/* </BootstrapTooltip> */}
                      <Button sx={{ width: "10%", textTransform: "none" }} onClick={generatePassword} >{t('security.random')}</Button>
                    </Box>
                    {errorPassword ?
                      <FormHelperText error >{t('profile.previousOldPassword')}</FormHelperText>
                      :
                      formik.touched.password && formik.errors.password ? <FormHelperText error >{formik.errors.password}</FormHelperText> : null
                    }
                    <Box display="flex" alignItems="center" mt={1} ml="20px">
                      <Checkbox color="primary" sx={{ pl: 0 }} checked={forceChangePassword} onChange={() => handleForceChangePassword()} />
                      <Typography variant="subtitle1" fontSize={16} lineHeight="23.92px" fontWeight={400} color="#404349">{t('security.forceChangePassword')}</Typography>
                    </Box>
                  </Box>
                  : null
                }
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 0 }}>
          <Box>
            <Button onClick={handleClose} color="primary" variant="outlined" sx={{ textTransform: "none", height: "45px" }}>
              {/* {t("label.cancel")} */}
              <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} color="#6B6B6B">Cancel</Typography>
            </Button>
          </Box>
          <Box>
            <Button disabled={isSubmitReset === true ? true : false} onClick={handleSubmitReset} color="primary" variant="contained" sx={{ textTransform: "none", height: "45px" }}>
              {/* {t("label.sendToApprove")} */}
              <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} color="#FFFFFF">Submit</Typography>
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default AttachFilesgoalDialog;
